import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import xToClose from "../../assets/images/close.png";
import "./contact.css";

export default function Contact() {
  //scroll to section
  function scrollToID(id) {
    document.querySelector(id).scrollIntoView({ behavior: "smooth" });
  }
  //prices
  const BASE_PRICE = 65;
  const ADDITIONAL_COPY = 10;
  //services offered
  const SERVICES_OFFERED = [
    {
      id: "notarization",
      serviceName: "Notarization",
      pricingHeader: "Pricing",
      pricing:
        "$" +
        BASE_PRICE +
        " per document\n$" +
        ADDITIONAL_COPY +
        " per additional copy",
    },
    {
      id: "drafting-assistance-will ",
      serviceName: "Drafting Assistance - Will",
      header: "Disclaimer",
      message:
        "I am a licensed paralegal in Ontario; however, under the Law Society of Ontario's regulations, paralegals are not permitted to provide legal services related to wills or estate planning. I will not be providing legal advice in the preparation of your will.\n\nMy involvement will be limited to assisting with the organization of the testator’s information and notarizing/witnessing the execution of the document in my capacity as a Notary Public and/or Commissioner for Taking Affidavits. \n\nI am not responsible for the legal content of this will. If there are any questions or concerns about the legal side of things, it’s a good idea to speak with a lawyer licensed in Ontario to make sure everything is in order.",
      pricingHeader: "Pricing",
      pricing:
        "$" +
        BASE_PRICE +
        " per document\n$" +
        ADDITIONAL_COPY +
        " per additional copy\n" +
        "*Notarization included",
    },
    {
      id: "general-inquiries",
      serviceName: "General Inquiries",
      header: " ",
      message:
        "Please fill out the form below to send me an email. I will respond as soon as possible.",
    },
  ];

  // Validation regexes
  const nameRegex = /^[a-zA-Z'\-\s]+$/;
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const phoneRegex = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

  //Modal
  const dialogRef = useRef(null);
  // const [isModalShow, setModalShow] = useState(false);

  const openModal = () => {
    dialogRef.current.showModal();
    // setModalShow(true);
  };

  const closeModal = () => {
    dialogRef.current.close();
    document.getElementById("contactForm").reset();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // setModalShow(false);
  };

  let form = useRef();

  const [isValidName, setNameValidity] = useState(false);
  const [isValidEmail, setEmailValidity] = useState(false);
  const [isValidPhone, setPhoneValidity] = useState(false);
  const [isFormValid, setFormValidity] = useState(false);
  const [selectedService, setSelectedService] = useState([]);

  // Handle service button selection
  const handleServiceButton = (service) => {
    setSelectedService((prevSelected) =>
      prevSelected.includes(service)
        ? prevSelected.filter((s) => s !== service)
        : [...prevSelected, service]
    );
  };

  // Show error message only after user leaves the field (onBlur)
  function handleBlur(evt) {
    validateForm();
    let field = document.getElementById(evt.target.id).value;
    let el = document.getElementById(evt.target.id + "-error");
    if (field.length > 0 && el) {
      el.classList.remove("hidden");
    }
    if (field.length === 0 && el) {
      el.classList.add("hidden");
    }
  }

  // Validate on focus and keyup
  const handleChange = (evt) => {
    validateForm();
  };

  // Validation functions (keep setting individual states)
  function validateName() {
    let name = document.getElementById("name").value.trimStart();
    setNameValidity(nameRegex.test(name) && name.length > 0);
  }

  function validateEmail() {
    let email = document.getElementById("email").value;
    setEmailValidity(emailRegex.test(email));
  }

  function validatePhone() {
    let phone = document.getElementById("phone").value;
    if (phone.length === 0) {
      setPhoneValidity(true);
    } else {
      setPhoneValidity(phoneRegex.test(phone));
    }
  }

  // validateForm just calls all validations (no setFormValidity here)
  function validateForm() {
    validateName();
    validateEmail();
    validatePhone();
  }

  // Now watch validation flags to update form validity
  useEffect(() => {
    setFormValidity(isValidName && isValidEmail && isValidPhone);
  }, [isValidName, isValidEmail, isValidPhone]);

  // Send email function
  const sendEmail = (evt) => {
    evt.preventDefault();

    //zfd notary services, contact us template
    emailjs
      .sendForm("service_6na6qpw", "template_tyvgxwj", form.current, {
        publicKey: "wOUwSxXCGKay3Xv4C",
      })
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (e) => {
          console.log("FAILED...", e.text);
        }
      );
    openModal();
  };

  return (
    <div className="contact">
      <div className="assistance">
        <h4>What do you need assistance with?</h4>
        {SERVICES_OFFERED.map((service) => (
          <>
            <div
              className={`service-container ${
                selectedService.length === 0
                  ? ""
                  : selectedService.includes(service.serviceName)
                  ? ""
                  : "hidden"
              }`}
            >
              <div className="btn-container">
                <button
                  id={service.id}
                  value={service.serviceName}
                  className="btn"
                  key={service.id}
                  type="button"
                  onClick={() => handleServiceButton(service.serviceName)}
                >
                  {/* {selectedService.includes(service.serviceName) && (
                    <img
                      src={`${process.env.PUBLIC_URL}/img/arrow-left.webp`}
                      alt="back arrow"
                    />
                  )} */}
                  {service.serviceName}
                </button>
              </div>
            </div>
            {selectedService.includes(service.serviceName) && (
              <>
                {service.pricingHeader && service.pricing && (
                  <div className="pricing-container fade-in">
                    <h5 className="serviceHeader">{service.pricingHeader}</h5>
                    <p className="serviceMessage">
                      {service.pricing.split("\n").map((line, index) => (
                        <span key={index}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </p>
                  </div>
                )}
                {service.header && service.message && (
                  <div className="message-container  fade-in">
                    <h5 className="serviceHeader">{service.header}</h5>
                    <p className="serviceMessage">
                      {service.message.split("\n").map((line, index) => (
                        <span key={index}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </p>
                  </div>
                )}
              </>
            )}
          </>
        ))}
      </div>
      <form
        id="contactForm"
        className={`form ${selectedService.length > 0 ? "fade-in" : ""}`}
        ref={form}
        onSubmit={sendEmail}
      >
        <div className="hidden">
          <input
            type="text"
            name="selectedService"
            value={selectedService.join(", ")}
            readOnly
          ></input>
        </div>
        <div className="formSection">
          <h4>Contact Information</h4>
          <div className="formField mt-0">
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Name"
              autoComplete="name"
              autoCapitalize="words"
              onFocus={handleChange}
              onKeyUp={handleChange}
              onBlur={handleBlur}
              required
            ></input>
            {!isValidName && (
              <label htmlFor="name" id="name-error" className="error hidden">
                *please enter valid name
              </label>
            )}
          </div>
          <div className="formField">
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Email Address"
              autoComplete="email"
              onFocus={handleChange}
              onKeyUp={handleChange}
              onBlur={handleBlur}
              required
            ></input>
            {!isValidEmail && (
              <label htmlFor="email" id="email-error" className="error hidden">
                *please enter valid email
              </label>
            )}
          </div>
          <div className="formField">
            <input
              type="number"
              id="phone"
              name="phone"
              placeholder="Phone Number (optional)"
              autoComplete="tel"
              onFocus={handleChange}
              onKeyUp={handleChange}
              onBlur={handleBlur}
            ></input>
          </div>
        </div>
        <div className="sendEmail">
          <button className="btn-small" type="submit" disabled={!isFormValid}>
            Send me an Email
          </button>
        </div>
      </form>
      {/* Modal */}
      <div className="modalBackdrop" onClick={closeModal}>
        <dialog ref={dialogRef}>
          <div className="dialogContent">
            <button
              className="xToClose"
              onClick={closeModal}
              onTouchStart={closeModal}
            >
              <img src={xToClose} alt="x to close button"></img>
            </button>
            <h2>Thank you!</h2>
            <p>Your request was sent successfully.</p>
          </div>
        </dialog>
      </div>
    </div>
  );
}
